module.exports = __webpack_public_path__ + "img/Emotional diagram-01.8c8f3b33.png";